import {Component, Mixins, Prop} from "vue-property-decorator";
import {sendResetPasswordEmail} from "~/modules/auth/service";
import {EmailStep} from "~/modules/auth/components/email-step";

@Component
class ChangePasswordEmailStep extends Mixins(EmailStep) {
  @Prop({type: String, required: true}) type: "lost-password" |  "account-activation";

  protected async send() {
    await sendResetPasswordEmail(this.email, this.type);
  }
}

export {ChangePasswordEmailStep}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-6547f46f/change-password-email-step.tsx" });